import { api } from ".";
import * as Actions from "../redux/constants/Auth";

const service = {};
const config = () => {
  return {
    headers: { Authorization: `${localStorage.getItem(Actions.AUTH_TOKEN)}` },
  };
};

const endpoint = "negative";

service.model = {
  active: false,
  label: "",
};

service.getParameters = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/parameters`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.putParameters = async function (data) {
  let result = null;
  await api
    .put(`/api/${endpoint}/parameters`, data, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.addExclusion = async function (idCreditOperation) {
  let result = null;
  await api
    .post(`/api/${endpoint}/parameters/addExclusion/${idCreditOperation}`, {}, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.delExclusion = async function (idCreditOperation) {
  let result = null;
  await api
    .delete(`/api/${endpoint}/parameters/delExclusion/${idCreditOperation}`, {}, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getExclusions = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/parameters/exclusions`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.sendNegativate = async function (data) {
  let result = null;
  await api
    .post(`/api/${endpoint}/batch/sendNegative`, data, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};
service.sendDenegativate = async function (data) {
  let result = null;
  await api
    .post(`/api/${endpoint}/batch/sendDenegative`, data, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getParametersLogs = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/parameters/logs`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getEventsLogs = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/events/logs`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getBatchsLogs = async function () {
  let result = null;
  await api
    .get(`/api/${endpoint}/batch/logs`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getNegativeItemsByBatchId = async function (idBatch) {
  let result = null;
  await api
    .get(`/api/${endpoint}/batch/items/${idBatch}`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getPdfDownload = async function (idBatch) {
  let result = null;
  await api
    .get(`/api/${endpoint}/batch/pdf/${idBatch}`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getEligibleNegative = async function () {
  let result = null;
  await api
    .get(`/api/creditOperation/installments/eligibleNegative`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

service.getEligibleDenegative = async function () {
  let result = null;
  await api
    .get(`/api/creditOperation/installments/eligibleDenegative`, config())
    .then((res) => {
      result = { data: res.data, error: false, type: res.status };
    })
    .catch((error) => {
      result = { data: null, error: true, type: error };
    });
  return result;
};

export default service;
